import React from "react";

interface FloatLeftProps {
    image: string;
    imageAlt: string;
    bullets: string[];
}

const SectionRight: React.FC<FloatLeftProps> = ({ image, imageAlt, bullets }) => {
    return (
        <>
            <div className="col-12 col-xl-7 order-xl-1">
                <ul className="services pl-3">
                    {bullets.map((bullet, index) => (
                        <li key={index} className="mb-4">{bullet}</li>
                    ))}
                </ul>
            </div>
            <div className="d-none d-lg-block col-lg-6 col-xl-5 order-xl-2">
                <img className="img-fluid mb-4 mb-xl-5 border-img" src={image} alt={imageAlt} />
            </div>
        </>
    );
};

export default SectionRight;

